<template>
    <div
        class="item"
        @click="onTransformerClick"
    >
        {{ transformer.transformerName }}
    </div>
</template>

<script setup lang="ts">
import { FlaggedTransformerDto } from '@/api/generated/HCA'
import { useRouter } from 'vue-router'

const props = defineProps<{
    transformer: FlaggedTransformerDto
}>()

const router = useRouter()

const onTransformerClick = () => {
    if (!props.transformer.transformerSid) {
        return
    }

    const route = router.resolve({
        name: 'Transformers_ConditionStatus',
        params: {
            transformerId: props.transformer.transformerSid,
        },
    })
    
    window.open(route.href, '_blank')
}
</script>

<style scoped lang="scss">
.item {
    padding: $spacing-xs $spacing-s;

    border: 1px solid transparent;
    border-radius: 4px;
    background-color: $pbl-background;

    font-weight: 500;
    transition: border-color 0.15s ease;

    user-select: none;
    cursor: pointer;
    color: $pbl-primary;

    &:hover:not(&:active) {
        border-color: $pbl-primary;
    }
}
</style>
